export class Word {
    id: string;
    name: string;
    oral: string;
    fileName: string;
    patientId: string;

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.oral = json.oral;
        this.fileName = json.fileName;
        this.patientId = json.patientId;
    }
}
